import { useState, useEffect } from "react";

const WA_LINK = "https://wa.me/5554996914900?text=Ol%C3%A1%2C%20gostaria%20de%20uma%20an%C3%A1lise%20do%20meu%20contrato%20banc%C3%A1rio.";

const navItems = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Áreas de Atuação", href: "#areas" },
  { label: "Revisão de Juros", href: "#revisao" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white shadow-sm border-b border-[#E6E6E6]"
          : "bg-white border-b border-[#E6E6E6]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-[80px]">
        {/* Logo */}
        <a href="#inicio" onClick={(e) => handleNav(e, "#inicio")} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/b0f92547-67a0-4c97-96b3-1197452eb2b3/fc98cc25-241d-4879-85d8-613dc6eb16cb_ivan-carlos-logo-transparente.png?v=c63336f769e63561aed8ffbf50c465c4"
            alt="Ivan Carlos Revisões de Juros"
            className="h-[66px] w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNav(e, item.href)}
              className={`text-sm font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer hover:text-[#B32025] ${
                scrolled ? "text-[#1A1A1A]" : "text-[#1A1A1A]"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* CTA + Mobile toggle */}
        <div className="flex items-center gap-4">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Falar no WhatsApp"
            className="hidden md:flex items-center justify-center bg-[#B32025] hover:bg-[#8E1A1E] text-white w-10 h-10 rounded-md transition-all duration-200 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl leading-none" />
            </div>
          </a>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-[#1A1A1A]"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t border-[#E6E6E6] overflow-hidden transition-all duration-300 ${
          menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="flex flex-col px-6 py-4 gap-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNav(e, item.href)}
              className="text-[#1A1A1A] text-sm font-medium py-2 border-b border-[#E6E6E6] last:border-0 cursor-pointer hover:text-[#B32025] transition-colors"
            >
              {item.label}
            </a>
          ))}
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-[#B32025] text-white text-sm font-semibold px-5 py-3 rounded-md mt-2 whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base leading-none" />
            </div>
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
}
